import React from 'react';
import type { Peer } from '../../hooks/usePeerNetwork';

interface PeerPresenceBarProps {
  remotePeers: Peer[];
}

function truncate(str: string, max: number): string {
  if (!str) return 'Unknown';
  return str.length > max ? str.slice(0, max) + '...' : str;
}

export default function PeerPresenceBar({ remotePeers }: PeerPresenceBarProps) {
  if (!remotePeers || remotePeers.length === 0) return null;

  return (
    <div
      style={{
        background: 'var(--bg-secondary, rgba(0,0,0,0.3))',
        borderTop: '1px solid var(--border)',
        padding: '6px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        overflow: 'hidden',
        minHeight: 32,
      }}
    >
      {remotePeers.map((peer) => (
        <div
          key={peer.machine_id}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            animation: 'peerFadeIn 0.4s ease',
          }}
        >
          <span
            style={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              backgroundColor: '#4CAF50',
              flexShrink: 0,
              animation: 'peerPulse 2s ease-in-out infinite',
            }}
          />
          <span
            style={{
              fontSize: 10,
              fontWeight: 600,
              color: 'var(--text-secondary)',
              whiteSpace: 'nowrap',
            }}
          >
            {truncate(peer.machine_name || peer.machine_id, 16)}
          </span>
          <span
            style={{
              fontSize: 8,
              fontWeight: 700,
              color: 'var(--text-tertiary)',
              letterSpacing: '0.06em',
              textTransform: 'uppercase' as const,
            }}
          >
            ONLINE
          </span>
        </div>
      ))}

      <style>{`
        @keyframes peerPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
        @keyframes peerFadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
